import {
  Box,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
} from '@mui/material';
import { useController } from 'react-hook-form';
import ThrottleConditionCard from './throttle-condition-card/throttle-condition-card.component';
import AddButton from './add-button/add-button.component';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

const ValueConditionField = () => {
  const { t } = useTranslation();

  const {
    field: { onChange: rhfOnChange, value: fieldValue, ...fieldRest },
    fieldState: { error },
  } = useController({ name: 'throttleSettings' });

  const handleAppend = () => {
    rhfOnChange([
      ...fieldValue,
      {
        id: uuidv4(), // Generate a unique identifier
        orderAmount: 0,
        processingTime: 1,
        // TODO: This logic will be changed in a future story.
        displayMessage: {
          EN: 'We will need a little more time to prepare your Order. Please select a new time. Estimated prep time for orders exceeding $0.00 is 1 minute.',
        },
      },
    ]);
  };

  const handleRemove = (index: number) => {
    const updatedArray = fieldValue.filter(
      (_item: any, i: number) => i !== index,
    );
    rhfOnChange(updatedArray);
  };

  return (
    <FormControl
      error={!!error}
      {...fieldRest}
      data-testid="SetPreparationTimeForm.ValueCondition.Field"
    >
      <Typography variant="h2">
        {t('forms.setPreparationTimeForm.fields.throttleSettings.title')}
      </Typography>
      <Stack spacing={2}>
        {fieldValue.map((condition, index) => (
          <ThrottleConditionCard
            key={condition.id} // Use the unique `id` here
            index={index}
            orderAmount={condition.orderAmount}
            processingTime={condition.processingTime}
            onRemove={handleRemove}
          />
        ))}
        <Box alignSelf="end">
          <AddButton onClick={handleAppend} />
          <FormHelperText>
            <IncFormHelperText error={error} />
          </FormHelperText>
        </Box>
      </Stack>
    </FormControl>
  );
};

export default ValueConditionField;
